import { render, staticRenderFns } from "./ChatVisitorInfo.vue?vue&type=template&id=65f8ed55&"
import script from "./ChatVisitorInfo.vue?vue&type=script&lang=js&"
export * from "./ChatVisitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatVisitorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports